import _ from "lodash";

export const isSystemAdmin = (login, type = null) => {
    if (!!login?.edit_system) return true;
    if (login && type) {
        if (!!_.get(login, 'permission_roles.' + type, false)) {
            return true
        }
    }
    return false;
}